import React from "react"
import { useNavigate } from "react-router-dom";
import noida from '../../assets/cityCafe/images (13).jpeg'
import gurgaon from '../../assets/cityCafe/images (14).jpeg'
import mumbai from '../../assets/cityCafe/mumbai.jpg'
import indore from '../../assets/cityCafe/5a.jpg'
import goa from '../../assets/cityCafe/goa.jpeg'
import { Helmet } from "react-helmet";

export const CityCafe = () => {
    const navigate = useNavigate();

    const highlights = [
        {
            img: noida,
            title: "NOIDA",
            route: "/city/Noida"
        },
        {
            img: gurgaon,
            title: "GURUGRAM",
            route: "/city/Gurugram"
        },
        {
            img: mumbai,
            title: "MUMBAI",
            route: "/city/Mumbai"
        },
        {
            img: indore,
            title: "INDORE",
            route: "/city/Indore"
        },
        {
            img: goa,
            title: "GOA",
            route: "/city/Goa"
        },
    ]

    return (
        <>
            <Helmet>
                <title>Investycoons | Explore Properties in Noida, Gurugram, Mumbai, Indore & Goa</title>
                <meta
                    name="description"
                    content="Explore residential & commercial real estate in Noida, Mumbai, Goa & more. Verified listings, top builders, 0% brokerage. Book your site visit today."
                />
            </Helmet>
            <div className="w-full bg-white py-12 px-4 sm:px-6 lg:px-20">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-xl sm:text-2xl md:text-3xl uppercase font-bold text-gray-800 mb-6 text-center">
                        Our Key Locations Across <span className="text-green-600">India</span>
                    </h2>
                    <p className="text-base sm:text-lg  text-gray-600 leading-relaxed text-justify mx-auto mb-12">
                        We offer premium residential and commercial properties across <span className="font-semibold text-gray-800">Noida, Delhi, Gurugram, Goa, Mumbai</span>, and <span className="font-semibold text-gray-800">Indore</span>. From ready-to-move flats, luxury villas, and builder floors to pre-leased offices, retail shops, and resort investments - we provide high-ROI opportunities in India’s top real estate markets.
                    </p>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-8">CITY CAFE</h3>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 justify-items-center">
                        {highlights.map((data, index) => (
                            <div
                                key={index}
                                onClick={() => navigate(`${data.route}`)}
                                className="flex flex-col items-center text-center cursor-pointer transition-transform duration-300 hover:scale-105"
                            >
                                <img
                                    src={data.img}
                                    alt={data.title}
                                    className="w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-full object-cover shadow-md hover:shadow-lg"
                                />
                                <h4 className="mt-4 text-base sm:text-lg font-semibold text-gray-900">{data.title}</h4>
                                <p className="text-gray-600 text-xs sm:text-sm">{data.subtitle}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div></>
    )
}